import { useCallback } from 'react';
import { useSortKitsState } from './useSortKitsState';
import { Complexes } from '../useKits';
import { useComplexesSortMutate } from 'app/dataProviders/complexes/sort/hooks';
import { OrgId } from 'app/common/types/id';
import { ComplexesListItem } from 'app/common/types/food/schools/complexes/sort';



type State = {
  kitList: Array<ComplexesListItem>
  pending: boolean,
  modified: boolean
}

type Handlers = {
  moveItem: (indexFrom: number, indexTo: number) => Promise<void>,
  submit: () => Promise<boolean>
  resetSort: () => void
}

interface Options {
  orgId: OrgId
  kits: Complexes
}


export function useSortKitsSubmit({ orgId, kits }: Options): [State, Handlers] {
  const { submit, pending } = useComplexesSortMutate()

  const [
    { kitList, modified },
    { moveItem, resetModified, resetSort },
  ] = useSortKitsState({ kits })


  const handleMoveItem = useCallback(async (indexFrom: number, indexTo: number) => {
    return moveItem(indexFrom, indexTo);
  }, [moveItem])

  const handleSubmit = useCallback(async () => {
    const res = await submit({ orgId, complexes: kitList });
    if (res) {
      resetModified()
    }
    return res
  }, [submit, resetModified, orgId, kitList])

  return [{
    kitList,
    modified,
    pending,
  }, {
    moveItem: handleMoveItem,
    submit: handleSubmit,
    resetSort
  }];
}
